import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Pagination } from '@carnica/ui-kit';
import React, { useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import { enhancedConnect } from "../../../utils";
import { useCarouselCommonContext } from "../context";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
export var _CarouselPagination = function _CarouselPagination() {
  var _useCarouselCommonCon = useCarouselCommonContext(),
    swiperInstance = _useCarouselCommonCon.swiperInstance;
  var _useState = useState(1),
    _useState2 = _slicedToArray(_useState, 2),
    activeSlide = _useState2[0],
    setActiveSlide = _useState2[1];
  useEffect(function () {
    var handleSwipeChange = function handleSwipeChange(swiper) {
      setActiveSlide(swiper.activeIndex + 1);
    };
    swiperInstance === null || swiperInstance === void 0 ? void 0 : swiperInstance.on('slideChange', handleSwipeChange);
    return function () {
      swiperInstance === null || swiperInstance === void 0 ? void 0 : swiperInstance.off('slideChange', handleSwipeChange);
    };
  }, [swiperInstance, swiperInstance === null || swiperInstance === void 0 ? void 0 : swiperInstance.activeIndex]);
  return /*#__PURE__*/React.createElement("div", {
    className: cx('pagination'),
    "data-t-id": "Carousel-CarouselPagination"
  }, /*#__PURE__*/React.createElement(Pagination, {
    activePoint: activeSlide,
    direction: "row",
    onPointClick: function onPointClick(point) {
      return swiperInstance === null || swiperInstance === void 0 ? void 0 : swiperInstance.slideTo(point - 1);
    },
    points: swiperInstance === null || swiperInstance === void 0 ? void 0 : swiperInstance.slides.length
  }));
};
export var CarouselPagination = enhancedConnect()(_CarouselPagination);